<template>
    <div class="main partner">
        <Header></Header>
        <div class="content">

            <div class="box">
                <cardHead title="圈舍分析"></cardHead>
                <div class="box-content">
                    <div class="left">
                        <div class="server">
                            活畜生长预警概况
                        </div>

                        <div class="line">
                            <div class="hot" style=" background-size: cover !important;" @click="goDialog('体温')" :class="{ noHot: warnNum.a14 <= 0 }">
                                <span>{{ warnNum.a14 }}<i>只</i></span>
                                <span>体温异常</span>
                            </div>
                            <div class="hot" style=" background-size: cover !important;" @click="goDialog('病毒')" :class="{ noHot: warnNum.a5 <= 0 }">
                                <span>{{ warnNum.a5 }}<i>只</i></span>
                                <span>病毒预警</span>
                            </div>
                            <div class="hot" style=" background-size: cover !important;" @click="goDialog('久治')" :class="{ noHot: warnNum.a6 <= 0 }">
                                <span>{{ warnNum.a6 }}<i>只</i></span>
                                <span>久治未愈</span>
                            </div>
                            <div class="hot" style=" background-size: cover !important;" @click="goDialog('消毒')" :class="{ noHot: warnNum.a20 <= 0 }">
                                <span>{{ warnNum.a20 }}<i>只</i></span>
                                <span>消毒预警</span>
                            </div>
                        </div>
                        <div class="line" style="margin-top: .25rem;">
                            <div class="info" @click="goDialog('发情')">
                                <img v-if="warnNum.a1 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>发情数量</span>
                                    <span :style="{ color: warnNum.a1 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a1 }}<i
                                            :style="{ color: warnNum.a1 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('配种')">
                                <img v-if="warnNum.a15 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>配种预警</span>
                                    <span :style="{ color: warnNum.a15 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a15 }}<i
                                            :style="{ color: warnNum.a15 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('久配')">
                                <img v-if="warnNum.a3 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>久配不孕</span>
                                    <span :style="{ color: warnNum.a3 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a3 }}<i
                                            :style="{ color: warnNum.a3 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('流产')">
                                <img v-if="warnNum.a4 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>流产数量</span>
                                    <span :style="{ color: warnNum.a4 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a4 }}<i
                                            :style="{ color: warnNum.a4 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                        </div>
                        <div class="line" style="margin-top: .25rem;">
                            <div class="info" @click="goDialog('临产')">
                                <img v-if="warnNum.a16 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>临产预警</span>
                                    <span :style="{ color: warnNum.a16 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a16 }}<i
                                            :style="{ color: warnNum.a16 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('超期')">
                                <img v-if="warnNum.a2 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>超期未产</span>
                                    <span :style="{ color: warnNum.a2 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a2 }}<i
                                            :style="{ color: warnNum.a2 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('产后')">
                                <img v-if="warnNum.a9 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>产后护理</span>
                                    <span :style="{ color: warnNum.a9 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a9 }}<i
                                            :style="{ color: warnNum.a9 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('断奶')">
                                <img v-if="warnNum.a17 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>断奶预警</span>
                                    <span :style="{ color: warnNum.a17 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a17 }}<i
                                            :style="{ color: warnNum.a17 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <!-- <div class="info" @click="goDialog('生病')">
                                <img v-if="warnNum.a5 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>生病数量</span>
                                    <span :style="{ color: warnNum.a5 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a5 }}<i
                                            :style="{ color: warnNum.a5 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('久治')">
                                <img v-if="warnNum.a6 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>久治未愈</span>
                                    <span :style="{ color: warnNum.a6 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a6 }}<i
                                            :style="{ color: warnNum.a6 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('体重')">
                                <img v-if="warnNum.a7 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>体重异常</span>
                                    <span :style="{ color: warnNum.a7 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a7 }}<i
                                            :style="{ color: warnNum.a7 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div> -->
                        </div>
                        <div class="line" style="margin-top: .25rem;">
                            <div class="info" @click="goDialog('体重')">
                                <img v-if="warnNum.a7 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>体重异常</span>
                                    <span :style="{ color: warnNum.a7 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a7 }}<i
                                            :style="{ color: warnNum.a7 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('运动')">
                                <img v-if="warnNum.a8 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>运动量异常</span>
                                    <span :style="{ color: warnNum.a8 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a8 }}<i
                                            :style="{ color: warnNum.a8 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('保险')">
                                <img v-if="warnNum.a18 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>保险预警</span>
                                    <span :style="{ color: warnNum.a18 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a18 }}<i
                                            :style="{ color: warnNum.a18 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                            <div class="info" @click="goDialog('检疫')">
                                <img v-if="warnNum.a10 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                <div class="text">
                                    <span>检验检疫</span>
                                    <span :style="{ color: warnNum.a10 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a10 }}<i
                                            :style="{ color: warnNum.a10 > 0 ? '#FFF200' : '#00FEFF' }">只</i></span>
                                </div>
                            </div>
                        </div>
                        <div class="server" style="margin-top: .3rem;">
                            活畜生长预警占比
                        </div>
                        <div id="barChart"></div>
                        <!-- <div class="hot" @click="goDialog('体温')" :class="{noHot:warnNum.a14<=0}">
                            <span>{{ warnNum.a14 }}<i>只</i></span>
                            <span>体温异常</span>
                        </div> -->
                    </div>
                    <div class="right">
                        <div class="top">
                            <div class="server">
                                硬件设备预警概况
                            </div>
                            <div class="line" style="margin-top: .65rem;margin-left: .68rem;justify-content: start;;">
                                <div class="info" @click="goDialog('圈舍')">
                                    <img v-if="warnNum.a11 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                    <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                    <div class="text">
                                        <span>圈舍环境异常</span>
                                        <span :style="{ color: warnNum.a11 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a11
                                        }}<i :style="{ color: warnNum.a11 > 0 ? '#FFF200' : '#00FEFF' }">个</i></span>
                                    </div>
                                </div>
                                <div class="info" style="margin-left: .86rem;" @click="goDialog('摄像')">
                                    <img v-if="warnNum.a12 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                    <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                    <div class="text">
                                        <span>摄像头异常</span>
                                        <span :style="{ color: warnNum.a12 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a12
                                        }}<i :style="{ color: warnNum.a12 > 0 ? '#FFF200' : '#00FEFF' }">个</i></span>
                                    </div>
                                </div>
                            </div>
                            <div class="server" style="margin-top: .66rem;">
                                硬件设备预警分析
                            </div>
                            <div class="footer">
                                <div class="f-l">
                                    <div id="pieChart1"></div>
                                    <span class="scale">
                                        异常占比：5%
                                    </span>
                                    <div class="txt">圈舍环境</div>
                                </div>
                                <div class="r-l">
                                    <div id="pieChart2"></div>
                                    <span class="scale">
                                        异常占比：5%
                                    </span>
                                    <div class="txt">摄像头</div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="server">
                                农资预警
                            </div>
                            <div class="inventory">
                                <div class="info" @click="goDialog('农资')">
                                    <img v-if="warnNum.a13 > 0" src="../../../assets/yq/warn/yellow-ring.png" alt="">
                                    <img v-else src="../../../assets/yq/warn/blue-ring.png" alt="">
                                    <div class="text">
                                        <span>农资不足预警</span>
                                        <span :style="{ color: warnNum.a13 > 0 ? '#FFF200' : '#00FEFF' }">{{ warnNum.a13
                                        }}<i :style="{ color: warnNum.a13 > 0 ? '#FFF200' : '#00FEFF' }">吨</i></span>
                                    </div>
                                </div>
                                <div id="pieChart3"></div>
                                <div class="txt-num">
                                    <div class="num">{{ num }}</div>
                                    <div class="txt">{{ txt }}</div>
                                </div>
                                <div class="single">
                                    <div class="sing">
                                        <span style="background-color: #5AF3B8;"></span>
                                        <span>草料</span>
                                    </div>
                                    <div class="sing">
                                        <span style="background-color: #93DBFF;"></span>
                                        <span>饲料</span>
                                    </div>
                                    <div class="sing" style="margin-top: .3rem;">
                                        <span style="background-color: #4D74FF;"></span>
                                        <span>兽药</span>
                                    </div>
                                    <div class="sing" style="margin-top: .3rem;">
                                        <span style="background-color: #FFD982;"></span>
                                        <span>其他</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="dialog-box" v-if="isShow">
            <div class="dialog">
                <div class="headers">
                    <span>{{ dialogTxet }}预警</span>
                    <span class="el-icon-close" @click="close"></span>
                </div>
                <dv-scroll-board :config="config" @click="details" @mouseover='mouseover'
                    style="width:11.24rem;height:4rem;margin-top:0.1rem;padding: 0 .11rem;" />
            </div>
        </div>
    </div>
</template>
<script>
import cardHead from "../fold/components/cardHead.vue";
import Header from "@/views/yqScreen/components/header.vue";
import myData from './components/warnData'
export default {
    components: {
        cardHead,
        Header
    },
    data() {
        return {
            warnNum: { a1: 21, a2: 0, a3: 1, a4: 0, a5: 1, a6: 1, a7: 0, a8: 0, a9: 0, a10: 0, a11: 1, a12: 0, a13: 21, a14: 0, a15: 0, a16: 0, a17: 0, a18: 0, a20: 0 },
            dialogTxet: "",
            isShow: false,
            config: {
                header: ['耳标编码', '预警时间', '预警说明', '操作'],
                data: [],
                align: ['center', 'left', 'left', 'left'],
                // columnWidth: [160, 180, 180, 320, 180, 180],
                headerHeight: 40,
                rowNum: 6,
                waitTime: 2000
            },
            pieData: [
                { value: 56, name: '大豆' },
                { value: 18, name: '土豆' },
            ],
            num: "60%",
            txt: "草料",
            warnTimer: null,
            messageTimer: null,
            numberTimer: null,
            warnData: [{ name: '草料', value: "60%" }, { name: '饲料', value: "36%" }, { name: '兽药', value: "1%" }, { name: '其他', value: "3%" },],
            cattle: { label: ['种公牛', '基础母牛', '公牛犊', '育肥牛', '育成牛', '牛犊', '怀胎母牛'], value: [145, 56, 67, 234, 59, 89, 100] },
        };
    },
    watch: {},
    created() {

    },
    mounted() {
        // this.pieChart(this.pieData, 'pieChart1', ['#FFF200', '#00FEFF'])
        // this.pieChart(this.pieData, 'pieChart2', ['#FFF200', '#5D2CFE'])
        //初始化获取体温预警信息
        this.getNumber()
        this.pieChart('pieChart1', ['#4BA5FF', '#FFF200', '#00FEFF', '#00FEFF'], '11')
        this.pieChart('pieChart2', ['#5D2CFE', '#FFF200', '#5D2CFE', '#5D2CFE'], '11')
        this.pieChart1('pieChart3')
        this.setBarData()
        // 3d饼图数据切换
        this.warnChange()
        // 实时短信
        // this.getChangeMessage()
        //体温预警数值
        // this.getChangeNumber()
    },
    update() {

    },
    destroyed() {
        clearInterval(this.warnTimer)
        clearInterval(this.messageTimer)
    },
    methods: {
        mouseover() {
            var divs = [...document.querySelectorAll('.dialog .row-item')]
            divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },
        // 体温预警列表
        getHotList() {
            this.$http({
                url: 'screenapp-service/screenWarningInfo/list',
                //请求方式
                method: 'post',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    var dataArr = []
                    data.result.list.forEach((item) => {
                        dataArr.push([item.livestockNumber, item.createTime, item.warningContent, `<span style="border: 0.01rem solid rgba(0,117,126,0.3);padding:.05rem .1rem;color:#00D7D3;cursor:pointer;background: rgba(255, 255, 255, 0.1);">查看档案</span>`])
                    })
                    this.config = { ...this.config, data: dataArr }
                } else {
                    // this.$message.error(data);
                }
            })
        },
        // 发送短信接口
        getMessage() {
            this.$http({
                url: 'screenapp-service/screenWarningInfo/tag',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "pastureId": '1647418543655018498',
                },
            }).then(res => {
                this.getNumber()
                if (res.data.code === 200) {

                } else {
                    // this.$message.error(data);
                }
            }).catch(err => {
                console.log(err);
                this.getNumber()
            })
        },
        // 获取体温预警数值
        getNumber() {
            this.$http({
                url: 'screenapp-service/screenWarningInfo/count',
                //请求方式
                method: 'post',
                //传递的参数
                data: {

                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.$nextTick(() => {
                        this.warnNum.a14 = data.result
                    })
                } else {
                    // this.$message.error(data);
                }
            })
        },
        //体温预警数值
        // getChangeNumber() {
        //     this.numberTimer = setInterval(() => {
        //         this.getNumber()
        //     }, 2000)
        // },
        // 实时短信
        getChangeMessage() {
            this.messageTimer = setInterval(() => {
                this.getMessage()
            }, 2000)
        },
        warnChange() {
            let val = 0
            this.warnTimer = setInterval(() => {
                this.txt = this.warnData[val].name
                this.num = this.warnData[val].value
                val++
                if (val >= 4) val = 0
            }, 2000)
        },
        details(val) {
            if (this.dialogTxet != "体温") {
                val.row[2] = '1号圈舍，耳标编号为230304010809的活畜出现体温异常预警，当前体温38度，请您及时跟踪处理！'
            }
            window.localStorage.setItem('WARNINFO', JSON.stringify(val))
            this.$router.push({ name: 'archive' })
            this.scrolling()
        },
        goDialog(v) {
            this.dialogTxet = v
            if (v == "体温") {
                this.getHotList()
            } else if (v == "发情") {
                this.config = { ...this.config, data: myData.heat }
            } else if (v == "圈舍") {
                this.config = { ...this.config, data: myData.pen }
            } else if (v == "久配") {
                this.config = { ...this.config, data: myData.long }
            } else if (v == "病毒") {
                this.config = { ...this.config, data: myData.fall }
            } else if (v == "久治") {
                this.config = { ...this.config, data: myData.jiuzhi }
            } else if (v == "农资") {
                this.config = { ...this.config, data: myData.means }
            } else {
                this.config = { ...this.config, data: [] }
            }
            this.isShow = true
            this.NoScrolling()
        },
        close() {
            this.isShow = false
            this.scrolling()
        },
        pieChart(dom, color, v) {
            var myChart = this.$echarts.init(document.getElementById(dom));
            let value = v; //图上角度数据
            var option = {
                backgroundColor: "",
                title: {
                    subtext: "总数量",
                    text: value,
                    x: "48%",
                    y: "40%",
                    itemGap: 5,
                    textStyle: {
                        color: color[2],
                        fontSize: 24,
                        fontWeight: "bold",
                        // fontFamily: 'YouSheBiaoTiHei',
                    },
                    subtextStyle: {
                        color: "#FFFFFF",
                        fontSize: 16,
                    },
                    textAlign: "center",
                },
                series: [
                    //外环
                    {
                        name: "外环",
                        type: 'pie',
                        silent: true,
                        clockwise: true,
                        radius: ['73%', '75%'],
                        label: {
                            show: false,
                        },
                        labelLine: {
                            show: false
                        },
                        itemStyle: {
                            color: color[0],
                        },
                        data: [0]
                    },
                    //内环
                    {
                        name: "内环",
                        type: 'pie',
                        silent: true,
                        clockwise: true,
                        radius: ['45%', '46%'],
                        label: {
                            show: false,
                        },
                        labelLine: {
                            show: false
                        },
                        itemStyle: {
                            color: color[0],
                        },
                        data: [0]
                    },
                    //外环
                    {
                        name: '',
                        type: 'pie',
                        labelLine: {
                            show: true,
                            length: 20,
                            length2: 80,
                            lineStyle: {
                                color: color[1],
                            }
                        },
                        radius: ['55%', '70%'],
                        silent: true,
                        clockwise: true,
                        startAngle: 90,
                        label: {
                            show: true,
                        },
                        data: [
                            {
                                value: value,
                                itemStyle: {
                                    normal: {
                                        //外环发光
                                        borderWidth: 0.5,
                                        shadowBlur: 20,
                                        borderColor: '#4bf3f9',
                                        shadowColor: '#9bfeff',
                                        color: { // 圆环的颜色
                                            colorStops: [{
                                                offset: 0,
                                                color: color[1], // 0% 处的颜色
                                            }, {
                                                offset: 1,
                                                color: color[1], // 100% 处的颜色
                                            }]
                                        },
                                    }
                                }
                            },
                            {
                                value: 100 - value,
                                label: {
                                    normal: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: color[2]
                                    }
                                }
                            }
                        ]
                    },
                ]
            };
            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        // 环状图
        pieChart1(dom) {
            // var sum = 0
            // Object.values(data).forEach((item) => {
            //     return sum = sum + item
            // }, 0)
            var myChart = this.$echarts.init(document.getElementById(dom));
            myChart.hideLoading()
            var data = [
                {
                    "name": "草料",
                    "value": 60,
                    "number": "60%",
                    itemStyle: {
                        // 透明度
                        opacity: 0.5,
                        // 扇形颜色
                        color: '#5AF3B8',
                    }
                },
                {
                    "name": "饲料",
                    "value": 36,
                    "number": "36%",
                    itemStyle: {
                        // 透明度
                        opacity: 0.5,
                        // 扇形颜色
                        color: '#93DBFF',
                    }
                },
                {
                    "name": "兽药",
                    "value": 1,
                    "number": "1%",
                    itemStyle: {
                        // 透明度
                        opacity: 0.5,
                        // 扇形颜色
                        color: '#4D74FF',
                    }
                },
                {
                    "name": "其他",
                    "value": 3,
                    "number": "3%",
                    itemStyle: {
                        // 透明度
                        opacity: 0.5,
                        // 扇形颜色
                        color: '#FFD982',
                    }
                },
            ]
            function getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, h) {
                // 计算
                let midRatio = (startRatio + endRatio) / 2;

                let startRadian = startRatio * Math.PI * 2;
                let endRadian = endRatio * Math.PI * 2;
                let midRadian = midRatio * Math.PI * 2;

                // 如果只有一个扇形，则不实现选中效果。
                if (startRatio === 0 && endRatio === 1) {
                    isSelected = false;
                }

                // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
                k = typeof k !== 'undefined' ? k : 1 / 3;

                // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
                let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
                let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

                // 计算高亮效果的放大比例（未高亮，则比例为 1）
                let hoverRate = isHovered ? 1.05 : 1;

                // 返回曲面参数方程
                return {
                    u: {
                        min: -Math.PI,
                        max: Math.PI * 3,
                        step: Math.PI / 32,
                    },

                    v: {
                        min: 0,
                        max: Math.PI * 2,
                        step: Math.PI / 20,
                    },

                    x: function (u, v) {
                        if (u < startRadian) {
                            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
                        }
                        if (u > endRadian) {
                            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
                        }
                        return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
                    },

                    y: function (u, v) {
                        if (u < startRadian) {
                            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
                        }
                        if (u > endRadian) {
                            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
                        }
                        return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
                    },

                    z: function (u, v) {
                        if (u < -Math.PI * 0.5) {
                            return Math.sin(u);
                        }
                        if (u > Math.PI * 2.5) {
                            return Math.sin(u) * h * 0.1;
                        }
                        return Math.sin(v) > 0 ? 1 * h * 0.1 : -1;
                    },
                };
            }


            var getPie3D = (pieData, internalDiameterRatio) => {
                let series = [];
                let sumValue = 0;
                let startValue = 0;
                let endValue = 0;
                let legendData = [];
                let k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3;

                // 为每一个饼图数据，生成一个 series-surface 配置
                for (let i = 0; i < pieData.length; i++) {
                    sumValue += pieData[i].value;

                    let seriesItem = {
                        name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
                        value: typeof pieData[i].value === 'undefined' ? `series${i}` : pieData[i].value,
                        type: 'surface',
                        parametric: true,
                        wireframe: {
                            show: false,
                        },
                        pieData: pieData[i],
                        pieStatus: {
                            selected: false,
                            hovered: false,
                            k: k,
                        },
                    };

                    if (typeof pieData[i].itemStyle != 'undefined') {
                        let itemStyle = {};

                        typeof pieData[i].itemStyle.color != 'undefined' ? (itemStyle.color = pieData[i].itemStyle.color) : null;
                        typeof pieData[i].itemStyle.opacity != 'undefined' ? (itemStyle.opacity = pieData[i].itemStyle.opacity) : null;

                        seriesItem.itemStyle = itemStyle;
                    }
                    seriesItem.label = {
                        formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                        backgroundColor: '#eee',
                        borderColor: '#aaa',
                        borderWidth: 1,
                        borderRadius: 4,
                        // shadowBlur:3,
                        // shadowOffsetX: 2,
                        // shadowOffsetY: 2,
                        // shadowColor: '#999',
                        // padding: [0, 7],
                        rich: {
                            a: {
                                color: '#999',
                                lineHeight: 22,
                                align: 'center'
                            },
                            // abg: {
                            //     backgroundColor: '#333',
                            //     width: '100%',
                            //     align: 'right',
                            //     height: 22,
                            //     borderRadius: [4, 4, 0, 0]
                            // },
                            hr: {
                                borderColor: '#aaa',
                                width: '100%',
                                borderWidth: 0.5,
                                height: 0
                            },
                            b: {
                                fontSize: 16,
                                lineHeight: 33
                            },
                            per: {
                                color: '#eee',
                                backgroundColor: '#334455',
                                padding: [2, 4],
                                borderRadius: 2
                            }
                        }
                    };
                    series.push(seriesItem);
                }
                // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
                // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
                for (let i = 0; i < series.length; i++) {
                    endValue = startValue + series[i].pieData.value;

                    series[i].pieData.startRatio = startValue / sumValue;
                    series[i].pieData.endRatio = endValue / sumValue;
                    series[i].parametricEquation = getParametricEquation(
                        series[i].pieData.startRatio,
                        series[i].pieData.endRatio,
                        false,
                        false,
                        k,
                        series[i].pieData.value
                    );

                    startValue = endValue;
                    legendData.push(series[i].name);
                }

                // 补充一个透明的圆环，用于支撑高亮功能的近似实现。
                series.push({
                    name: 'mouseoutSeries',
                    type: 'surface',
                    parametric: true,
                    wireframe: {
                        show: false,
                    },
                    itemStyle: {
                        opacity: 0,
                    },
                    parametricEquation: {
                        u: {
                            min: 0,
                            max: Math.PI * 2,
                            step: Math.PI / 20,
                        },
                        v: {
                            min: 0,
                            max: Math.PI,
                            step: Math.PI / 20,
                        },
                        x: function (u, v) {
                            return Math.sin(v) * Math.sin(u) + Math.sin(u);
                        },
                        y: function (u, v) {
                            return Math.sin(v) * Math.cos(u) + Math.cos(u);
                        },
                        z: function (u, v) {
                            return Math.cos(v) > 0 ? 0.1 : -0.1;
                        },
                    },
                });

                // 准备待返回的配置项，把准备好的 legendData、series 传入。
                let option = {
                    backgroundColor: 'transparent',
                    title: {
                        subtext: '',
                        text: '',
                        x: "40%",
                        y: "28%",
                        itemGap: 5,
                        textStyle: {
                            color: '#FFFFFF',
                            fontSize: 24,
                            fontWeight: "bold",
                            // fontFamily: 'YouSheBiaoTiHei',
                        },
                        subtextStyle: {
                            color: "#FFFFFF",
                            fontSize: 16,
                        },
                        textAlign: "center",
                    },
                    tooltip: {
                        formatter: (params) => {
                            if (params.seriesName !== 'mouseoutSeries') {
                                this.txt = params.seriesName
                                return `${params.seriesName
                                    }<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color
                                    };"></span>${option.series[params.seriesIndex].pieData.number}`;
                            }
                        },
                    },
                    xAxis3D: {
                        min: -1,
                        max: 1,
                    },
                    yAxis3D: {
                        min: -1,
                        max: 1,
                    },
                    zAxis3D: {
                        min: -1,
                        max: 1,
                    },
                    grid3D: {
                        left: '-10%',
                        top: -40,
                        show: false,
                        boxHeight: 5,
                        viewControl: {
                            //3d效果可以放大、旋转等，请自己去查看官方配置
                            alpha: 38,
                            beta: 30,
                            rotateSensitivity: 0,
                            zoomSensitivity: 0,
                            panSensitivity: 0,
                            autoRotate: true,
                        },
                        //后处理特效可以为画面添加高光、景深、环境光遮蔽（SSAO）、调色等效果。可以让整个画面更富有质感。
                        postEffect: {
                            //配置这项会出现锯齿，请自己去查看官方配置有办法解决
                            enable: true,
                            bloom: {
                                enable: true,
                                bloomIntensity: 0,
                            },
                            SSAO: {
                                enable: false,
                                quality: 'medium',
                                radius: 2,
                            },
                        },
                    },
                    series: series,
                };
                return option;
            }
            // 监听 mouseover，近似实现高亮（放大）效果
            // myChart.on('mouseover', function (params) {
            //     // 准备重新渲染扇形所需的参数
            //     let isSelected;
            //     let isHovered;
            //     let startRatio;
            //     let endRatio;
            //     let k;
            //     let i;

            //     // 如果触发 mouseover 的扇形当前已高亮，则不做操作
            //     if (hoveredIndex === params.seriesIndex) {
            //         return;

            //         // 否则进行高亮及必要的取消高亮操作
            //     } else {
            //         // 如果当前有高亮的扇形，取消其高亮状态（对 option 更新）
            //         if (hoveredIndex !== '') {
            //             // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 false。
            //             isSelected = option.series[hoveredIndex].pieStatus.selected;
            //             isHovered = false;
            //             startRatio = option.series[hoveredIndex].pieData.startRatio;
            //             endRatio = option.series[hoveredIndex].pieData.endRatio;
            //             k = option.series[hoveredIndex].pieStatus.k;
            //             i = option.series[hoveredIndex].pieData.value === option.series[0].pieData.value ? 35 : 10;
            //             // 对当前点击的扇形，执行取消高亮操作（对 option 更新）
            //             option.series[hoveredIndex].parametricEquation = this.getParametricEquation(
            //                 startRatio,
            //                 endRatio,
            //                 isSelected,
            //                 isHovered,
            //                 k,
            //                 i
            //             );
            //             option.series[hoveredIndex].pieStatus.hovered = isHovered;

            //             // 将此前记录的上次选中的扇形对应的系列号 seriesIndex 清空
            //             hoveredIndex = '';
            //         }

            //         // 如果触发 mouseover 的扇形不是透明圆环，将其高亮（对 option 更新）
            //         if (params.seriesName !== 'mouseoutSeries') {
            //             // 从 option.series 中读取重新渲染扇形所需的参数，将是否高亮设置为 true。
            //             isSelected = option.series[params.seriesIndex].pieStatus.selected;
            //             isHovered = true;
            //             startRatio = option.series[params.seriesIndex].pieData.startRatio;
            //             endRatio = option.series[params.seriesIndex].pieData.endRatio;
            //             k = option.series[params.seriesIndex].pieStatus.k;

            //             // 对当前点击的扇形，执行高亮操作（对 option 更新）
            //             option.series[params.seriesIndex].parametricEquation = getParametricEquation(
            //                 startRatio,
            //                 endRatio,
            //                 isSelected,
            //                 isHovered,
            //                 k,
            //                 option.series[params.seriesIndex].pieData.value + 5
            //             );
            //             option.series[params.seriesIndex].pieStatus.hovered = isHovered;

            //             // 记录上次高亮的扇形对应的系列号 seriesIndex
            //             hoveredIndex = params.seriesIndex;
            //         }

            //         // 使用更新后的 option，渲染图表
            //         myChart.setOption(option);
            //     }
            // });


            var option = getPie3D(data, 0.71);

            // var Time = setInterval(function () {
            //     var dataItem = data[0]
            //     data[0] = data[1]
            //     data[1] = data[2]
            //     data[2] = dataItem
            //     myChart.setOption(option)
            // }, 1000);

            myChart.clear();
            myChart.setOption(option)
            window.addEventListener('resize', () => {
                myChart.resize()
            })
        },
        // 存栏柱状图
        setBarData() {
            var chart = this.$echarts.init(document.getElementById('barChart'))
            // 隐藏动画加载效果。
            chart.hideLoading()
            let xaxisData = ['发情数量', '产后护理', '体温异常', '检验检疫', '生病数量', '治愈数量', '运动量异常', '体重异常', '久配不孕', '流产数量', '超期未产',]
            let yaxisData = [210, 100, 90, 38, 20, 20, 8, 5, 4, 2, 3,]
            const offsetX = 18;
            const offsetY = 9;
            // 绘制左侧面
            const CubeLeft = this.$echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    // 会canvas的应该都能看得懂，shape是从custom传入的
                    const xAxisPoint = shape.xAxisPoint;
                    const c0 = [shape.x, shape.y];
                    const c1 = [shape.x - offsetX, shape.y - offsetY];
                    const c2 = [xAxisPoint[0] - offsetX, xAxisPoint[1] - offsetY];
                    const c3 = [xAxisPoint[0], xAxisPoint[1]];
                    ctx
                        .moveTo(c0[0], c0[1])
                        .lineTo(c1[0], c1[1])
                        .lineTo(c2[0], c2[1])
                        .lineTo(c3[0], c3[1])
                        .closePath();
                },
            });

            // 绘制右侧面
            const CubeRight = this.$echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    const xAxisPoint = shape.xAxisPoint;
                    const c1 = [shape.x, shape.y];
                    const c2 = [xAxisPoint[0], xAxisPoint[1]];
                    const c3 = [xAxisPoint[0] + offsetX, xAxisPoint[1] - offsetY];
                    const c4 = [shape.x + offsetX, shape.y - offsetY];
                    ctx
                        .moveTo(c1[0], c1[1])
                        .lineTo(c2[0], c2[1])
                        .lineTo(c3[0], c3[1])
                        .lineTo(c4[0], c4[1])
                        .closePath();
                },
            });

            // 绘制顶面
            const CubeTop = this.$echarts.graphic.extendShape({
                shape: {
                    x: 0,
                    y: 0,
                },
                buildPath: function (ctx, shape) {
                    const c1 = [shape.x, shape.y];
                    const c2 = [shape.x + offsetX, shape.y - offsetY]; //右点
                    const c3 = [shape.x, shape.y - offsetX];
                    const c4 = [shape.x - offsetX, shape.y - offsetY];
                    ctx
                        .moveTo(c1[0], c1[1])
                        .lineTo(c2[0], c2[1])
                        .lineTo(c3[0], c3[1])
                        .lineTo(c4[0], c4[1])
                        .closePath();
                },
            });

            // 注册三个面图形
            this.$echarts.graphic.registerShape("CubeLeft", CubeLeft);
            this.$echarts.graphic.registerShape("CubeRight", CubeRight);
            this.$echarts.graphic.registerShape("CubeTop", CubeTop);

            var option = {
                backgroundColor: "",
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                    // backgroundColor: "rgba(255,255,255,0.75)",
                    extraCssText: "box-shadow: 2px 2px 4px 0px rgba(0,0,0,0.3);",
                    textStyle: {
                        fontSize: 14,
                        color: "#000",
                    },
                    formatter: (params, ticket, callback) => {
                        const item = params[1];
                        return item.name + " : " + item.value + " 只";
                    },
                },
                grid: {
                    top: '20%',
                    left: '3%',
                    right: '4%',
                    bottom: '4%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#00FEFF',
                        // rotate: 30,
                        // interval: 'auto',
                        textStyle: {
                            fontSize: 12
                        },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: 'rgba(2,72,99,0.5)',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true,
                        // interval: 0,
                        // alignWithLabel:1,
                        lineStyle: {
                            dashOffset: 5
                        },
                        // length:10
                    },
                    data: xaxisData,
                },
                yAxis: {
                    name: '单位(只)',
                    nameTextStyle: {
                        color: '#00FEFF',
                        padding: [3, 5, 0, 0],
                    },
                    type: 'value',
                    splitNumber: 4,
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisTick: { show: false },

                    axisLine: {
                        show: true, // Y轴线
                        lineStyle: {
                            color: 'rgba(2,72,99,0.5)',
                        },
                    },
                    axisLabel: {
                        color: '#00FEFF',
                        textStyle: {
                            fontSize: 12
                        }
                    },
                },
                series: [
                    {
                        type: "custom",
                        animation: true,
                        animationEasing: 'cubicOut',
                        animationDurationUpdate: 2000,
                        animationEasingUpdate: 'cubicInOut',
                        universalTransition: {
                            enabled: true
                        },
                        renderItem: (params, api) => {
                            const location = api.coord([api.value(0), api.value(1)]);
                            return {
                                type: "group",
                                children: [
                                    {
                                        type: "CubeLeft",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0],
                                            y: location[1],
                                            xAxisPoint: api.coord([api.value(0), 0]),
                                        },
                                        style: {
                                            fill: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {
                                                    offset: 0,
                                                    color: '#00889b'
                                                },
                                                {
                                                    offset: 0.5,
                                                    color: '#028195',
                                                },
                                                {
                                                    offset: 0.95,
                                                    color: '#02425f'
                                                },
                                                {
                                                    offset: 1,
                                                    color: '#022446'
                                                }
                                            ]),
                                        },
                                    },
                                    {
                                        type: "CubeRight",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0],
                                            y: location[1],
                                            xAxisPoint: api.coord([api.value(0), 0]),
                                        },
                                        style: {
                                            fill: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {
                                                    offset: 0,
                                                    color: '#01405d'
                                                },
                                                {
                                                    offset: 0.5,
                                                    color: '#023b5a',
                                                },
                                                {
                                                    offset: 0.95,
                                                    color: '#022244'
                                                },
                                                {
                                                    offset: 1,
                                                    color: '#022446'
                                                }
                                            ]),
                                        },
                                    },
                                    {
                                        type: "CubeTop",
                                        shape: {
                                            api,
                                            xValue: api.value(0),
                                            yValue: api.value(1),
                                            x: location[0],
                                            y: location[1],
                                            xAxisPoint: api.coord([api.value(0), 0]),
                                        },
                                        style: {
                                            fill: '#00feff'
                                        },
                                    },
                                ],
                            };
                        },
                        data: yaxisData,
                    },
                    {
                        type: "bar",
                        itemStyle: {
                            color: "transparent",
                        },
                        label: {
                            normal: {
                                show: false,
                                position: 'top',
                                fontSize: 16,
                                color: 'rgba(255,255,255,0.7)',
                                offset: [0, -15],
                            },
                        },
                        data: yaxisData,
                    },
                ],
            };
            if (option && typeof option === "object") {
                var index = 0; //播放所在下标
                var mTime = setInterval(function () {
                    chart.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,
                        dataIndex: index
                    });
                    index++;
                    if (index >= 11) {
                        index = 0;
                    }
                }, 2800);
            }

            chart.clear();
            chart.setOption(option)
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },
    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 24rem;
    // height: 13.5rem;
    min-height: 100vh;
    margin: 0 auto;
    background: url('../../../assets/yq/animal-bg.png');
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;

    .head {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.2rem;
        background: url('../../../assets/yq/headbg.png');
        background-size: 100% 100%;
        font-size: 0.55rem;
        font-family: AlibabaPuHuiTi-Bold, AlibabaPuHuiTi;
        font-weight: 700;
        color: #19ECFF;
        letter-spacing: 5px;

        .gobcak {
            position: absolute;
            bottom: 0;
            left: 0.25rem;
            font-size: .2rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #00E0DB;
            display: flex;
            align-items: center;
            cursor: pointer;
            width: 3rem;

            img {
                width: .3rem;
                height: .3rem;
            }

            span {
                margin-left: .05rem;
            }
        }
    }


    .gobcak {
        width: .875rem;
        height: .4375rem;
        position: absolute;
        z-index: 99;
        bottom: -0.25rem;
        left: 0.25rem;
        font-size: .2rem;
        font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
        font-weight: 400;
        color: #00E0DB;
        display: flex;
        align-items: center;
        cursor: pointer;

        img {
            width: .3rem;
            height: .3rem;
        }

        span {
            margin-left: .05rem;
        }
    }


    .content {
        padding: .41rem 0.39rem;
        box-sizing: border-box;
        display: flex;
        flex: 1;
        flex-direction: column;
        // min-height: 12.5rem;
        // min-height: calc(100vh - 1rem);
        position: relative;

        .box {
            width: 100%;
            display: flex;
            flex-direction: column;
            flex: 1;
            background: url('../../../assets/yq/fold/rectangle1.png');

            // background-position: ;
            .box-content {
                flex: 1;
                padding: 0 0.29rem;
                padding-bottom: 0.25rem;
                display: flex;
                justify-content: space-between;

                .left {
                    position: relative;
                    width: 13rem;
                    height: 10.35rem;
                    background: url('../../../assets/yq/warn/warningbg.png');
                    background-size: 100% 100%;


                    #barChart {
                        width: 100%;
                        height: 4.3rem;
                        // margin-top: .2rem;
                    }

                    .hot {
                        position: relative;
                        width: 2.46rem;
                        height: 2.04rem;
                        background: url('../../../assets/yq/warn/hot.png');
                        background-size: 100% 100%;
                        cursor: pointer;
                        animation-name: FadeIn;
                        animation-duration: 1s;
                        animation-direction: alternate;
                        animation-iteration-count: infinite;

                        span:nth-child(1) {
                            position: absolute;
                            left: 1.1rem;
                            top: 0.5rem;
                            margin-top: .15rem;
                            font-size: 0.25rem;
                            font-family: Impact-Regular, Impact;
                            font-weight: 400;
                            color: #FFF200;

                            i {
                                font-style: normal;
                                font-size: 0.15rem;
                                font-family: Impact-Regular, Impact;
                                font-weight: 700;
                                color: #FFF200;
                                padding-left: .05rem;

                            }
                        }

                        span:nth-child(2) {
                            font-size: 0.2rem;
                            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                            font-weight: 500;
                            color: #061B3A;
                            position: absolute;
                            left: 0.85rem;
                            top: 1.3rem;
                        }
                    }

                    .noHot {
                        background: url('../../../assets/yq/warn/noHot.png') !important;
                        animation-name: none;

                        span:nth-child(1) {
                            color: #00FEFF !important;

                            i {
                                color: #00FEFF !important;
                            }
                        }
                    }
                }

                .right {
                    width: 9.44rem;
                    margin-left: .28rem;

                    .top {
                        height: 5.98rem;
                        background: url('../../../assets/yq/warn/warningbg1.png');
                        background-size: 100% 100%;

                        .footer {
                            margin-top: .3rem;
                            display: flex;

                            .f-l {
                                position: relative;

                                #pieChart1 {
                                    width: 4.72rem;
                                    height: 2.6rem;
                                }

                                .scale {
                                    position: absolute;
                                    top: 0rem;
                                    right: 1rem;
                                }

                                .txt {
                                    position: absolute;
                                    bottom: 0;
                                    left: 2rem
                                }
                            }

                            .r-l {
                                position: relative;

                                #pieChart2 {
                                    width: 4.72rem;
                                    height: 2.6rem;
                                }

                                .scale {
                                    position: absolute;
                                    top: 0rem;
                                    right: 1rem;
                                }

                                .txt {
                                    position: absolute;
                                    bottom: 0;
                                    left: 2.2rem
                                }
                            }

                            .scale {
                                font-size: 0.15rem;
                                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                font-weight: 400;
                                color: #FFF200;
                            }

                            .txt {
                                font-size: 0.18rem;
                                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                                font-weight: 500;
                                color: #FFFFFF;
                            }
                        }
                    }

                    .bottom {
                        height: 4.08rem;
                        background: url('../../../assets/yq/warn/warningbg2.png');
                        background-size: 100% 100%;
                        margin-top: .3rem;

                        .inventory {
                            position: relative;
                            margin-left: .68rem;
                            display: flex;

                            .info {
                                display: flex;
                                align-items: flex-end;
                                width: 2.93rem;
                                height: 1.23rem;
                                cursor: pointer;

                                img {
                                    width: .91rem;
                                    height: .74rem;
                                }

                                .text {
                                    display: flex;
                                    flex-direction: column;
                                    margin-left: .25rem;

                                    span {
                                        font-size: 0.18rem;
                                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                        font-weight: 400;
                                        color: #FFFFFF;
                                    }

                                    span:nth-child(2) {
                                        margin-top: .15rem;
                                        font-size: 0.25rem;
                                        font-family: Impact-Regular, Impact;
                                        font-weight: 400;
                                        color: #00FEFF;

                                        i {
                                            font-style: normal;
                                            font-size: 0.15rem;
                                            font-family: Impact-Regular, Impact;
                                            font-weight: 700;
                                            color: #00FEFF;
                                            padding-left: .05rem;

                                        }
                                    }
                                }
                            }

                            #pieChart3 {
                                width: 6rem;
                                height: 3.6rem;
                            }

                            .txt-num {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                position: absolute;
                                top: 1.1rem;
                                left: 4.3rem;
                                width: 2rem;

                                .num {
                                    font-size: 0.3rem;
                                    font-family: Source Han Sans-Medium, Source Han Sans;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }

                                .txt {
                                    padding-top: .1rem;
                                    font-size: 0.18rem;
                                    font-family: Source Han Sans-Regular, Source Han Sans;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                }
                            }

                            .single {
                                position: absolute;
                                left: 4rem;
                                bottom: 0.4rem;
                                display: flex;
                                flex-wrap: wrap;

                                .sing {
                                    display: flex;
                                    align-items: center;
                                    width: 2rem;

                                    span:nth-child(1) {
                                        display: block;
                                        width: .2rem;
                                        height: .2rem;
                                    }

                                    span:nth-child(2) {
                                        font-size: 0.18rem;
                                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                                        font-weight: 400;
                                        color: #FFFFFF;
                                        margin-left: .15rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }
    }

    @keyframes FadeIn {
        0% {
            transform: scale(1);
        }

        25% {
            transform: scale(0.9);
        }

        50% {
            transform: scale(0.9);
        }

        75% {
            transform: scale(0.9);
        }

        100% {
            transform: scale(1);
        }

    }

    .server {
        font-size: 0.23rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #00FEFF;
        padding-top: .2rem;
        padding-left: .25rem;
    }

    .line {
        display: flex;
        justify-content: space-around;

        .info {
            display: flex;
            align-items: flex-end;
            cursor: pointer;

            img {
                width: .91rem;
                height: .74rem;
            }

            .text {
                display: flex;
                flex-direction: column;
                margin-left: .25rem;

                span {
                    font-size: 0.18rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #FFFFFF;
                }

                span:nth-child(2) {
                    margin-top: .15rem;
                    font-size: 0.25rem;
                    font-family: Impact-Regular, Impact;
                    font-weight: 400;
                    color: #00FEFF;

                    i {
                        font-style: normal;
                        font-size: 0.15rem;
                        font-family: Impact-Regular, Impact;
                        font-weight: 700;
                        color: #00FEFF;
                        padding-left: .05rem;

                    }
                }
            }
        }
    }

    .dialog-box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: transparent;
        opacity: 1;
        z-index: 99999999;

        .dialog {
            // position: fixed;
            // top: 50%;
            // left: 50%;
            // transform: translate(-5.625rem, -2.315rem);
            width: 11.25rem;
            height: 4.63rem;
            background: url('../../../assets/yq/warn/dialogbg.png');
            background-size: 100% 100%;

            .headers {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                height: 0.48rem;
                background: rgba(0, 174, 255, 0.6);
                border-radius: 0.05rem 0.05rem 0rem 0rem;
                padding-left: .25rem;
                padding-right: .11rem;

                span:nth-child(1) {
                    position: relative;
                    font-size: 0.23rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #00FEFF;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0.05rem;
                        bottom: -0.15rem;
                        width: 0.75rem;
                        height: 0.03rem;
                        background: #00FEFF;
                    }
                }

                span:nth-child(2) {
                    font-size: 0.28rem;
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: #FFFFFF;
                    cursor: pointer;
                }
            }
        }
    }

}
</style>
<style lang="scss">
.partner {

    .partner .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    // .el-select > .el-input{
    //     width: auto;
    // }
    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: 0.01rem solid rgba(25, 236, 255, 0.4);
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        // padding: 0 0 0 .4rem;
        width: 3.23rem !important;
    }

    .header {
        background: rgba(0, 174, 255, 0.3) !important;
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #19ECFF;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
    }

    .rows {
        // height: 3.5rem!important;
        padding: .05rem 0 .3rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                // margin-left: .6rem !important;
            }
        }
    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    .ceil:first-child {
        // color: #FFC300;
    }

    // 排名轮播
    .dv-scroll-ranking-board .ranking-column {
        height: 0.15rem;
        background: #102c41;
        border: none;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-top: 5px;
    }

    .dv-scroll-ranking-board .ranking-column .inside-column {
        width: 5.5rem;
        height: 0.15rem;
        background: linear-gradient(270deg, #FFE11D 0%, #00E0DB 100%) !important;
        border-radius: 0.6rem 0.6rem 0.6rem 0.6rem !important;
        margin-bottom: 0;
        overflow: hidden;
    }

    .dv-scroll-ranking-board .ranking-column .shine {
        background-color: transparent !important;
        animation: none !important;
    }

    .dv-scroll-ranking-board .ranking-info .rank {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .dv-scroll-ranking-board .ranking-info .info-name {
        font-size: 0.18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
    }

    .ranking-value {
        font-size: 0.15rem;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #FFE11D;
    }

    .dv-water-pond-level canvas {
        border: 1px solid #21EEE9;
        margin-left: .09rem;
        margin-top: .09rem;
    }

    .dv-water-pond-level text {
        font-size: 0.23rem !important;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN !important;
        font-weight: 500 !important;
        color: #010E26 !important;
        opacity: 0 !important;

    }

}
</style>